import PropTypes from "prop-types";
import React, { ReactElement } from "react";

const TopHeading = ({ total, refetch }): ReactElement => {
  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row d-flex-sb mb-15">
          <div className="col-lg-6 col-md-6 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l wrap d-flex-nowrap d-flex-base">
                Transaction List{" "}
                <span className="d-flex-l ml-1">
                  {total || 0} Transaction(s)
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TopHeading.propTypes = {
  UserId: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  name: PropTypes.string,
};

export default TopHeading;
